<template>
  <UIDialog
    :is-open
    :z-index
    size="2md"
    title="Add Accounts and Assets"
    @close="handleClose"
  >
    <CreateActions @click="handleClose" />
  </UIDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass } from '@types'

import { UIDialog } from '@ui/modals'
import CreateActions from '@/views/components/CreateActions.vue'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const zIndex = computed(() => props.modal.zIndex)
const isOpen = computed(() => props.modal.isOpened)

const handleClose = () => {
  props.modal.close()
}
</script>
